import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import GetStarted from "./components/GetStarted";
import Services from "./components/Services";
import Welcome from "./components/Welcome";
import StartFirstText from "./components/StartFirstText";
import NormalUserLayout from "../layouts/NormalUserLayout/NormalUserLayout";

// Site stylesheets (assets/css/main.css + KeysHome.css) are imported by Header,
// which every page of the site renders.

function KeysHome() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      mirror: false
    });
  }, []);

  return (
    <div className="KeysHome">
      <NormalUserLayout>
        <Header />
        <main className="main">
          <Hero />
          <StartFirstText />
          <Services />
          <Welcome />
          <GetStarted />
          <Services />
        </main>
        <Footer />
      </NormalUserLayout>
    </div>
  );
}

export default KeysHome;
